import React from 'react';
import type { GetSurveysToolPart, ConciergeMessagePart } from '../../types/conciergeToolTypes';
import { isCallState, isOutputState } from './types';
import { SurveyCarousel } from '../SurveyCarousel';

export function SurveysPart({ part, allParts }: { part: GetSurveysToolPart; allParts: ConciergeMessagePart[] }) {
  if (isCallState(part.state)) return null;

  const output = part.output;
  if (isOutputState(part.state) && output?.surveys?.length && output.surveys.length > 0) {
    return <SurveyCarousel surveys={output.surveys} />;
  }

  return null;
}
